import React from 'react';
import {
    Button,
    Dialog, DialogActions, DialogBody, DialogContent, DialogSurface, DialogTitle, Tooltip
} from '@fluentui/react-components';
import {NewFilled, ProhibitedRegular} from '@fluentui/react-icons';
import {useNavigate} from 'react-router-dom';
import {useSelector} from 'react-redux';
import {RootState} from '../../Store/Store';
import {useStartNewCart} from './useStartNewCart';
import {useLocalization} from '../Helpers/useLocalization';

/**
 * Inline blocked-cart notice for full-page contexts (ProductPage, BundlePage, etc.)
 * Shows a red prohibited icon + label. Clicking opens a dialog with navigation options.
 */
const BlockedCartNotice: React.FC = () => {
    const nav = useNavigate();
    const settings = useSelector((state: RootState) => state.cart);
    const { startNewCart, canStartNewCart } = useStartNewCart();
    const [open, setOpen] = React.useState(false);
    const L = useLocalization();

    return (
        <>
            <Tooltip content={L('localization_cart_blocked_tooltip')} relationship="label">
                <Button
                    appearance="subtle"
                    icon={<ProhibitedRegular style={{color: '#d13438'}} />}
                    onClick={() => setOpen(true)}
                    style={{paddingLeft: 0}}
                >
                    <span style={{color: '#d13438', fontWeight: 600}}>{L('localization_cart_blocked_title')}</span>
                </Button>
            </Tooltip>
            <Dialog open={open} onOpenChange={(_, d) => setOpen(d.open)}>
                <DialogSurface>
                    <DialogBody>
                        <DialogTitle>{L('localization_cart_blocked_title')}</DialogTitle>
                        <DialogContent>
                            {L('localization_cart_blocked_body')}{canStartNewCart ? ` ${L('localization_cart_blocked_body_new_cart')}` : ''}
                        </DialogContent>
                        <DialogActions>
                            <Button appearance="primary" onClick={() => { setOpen(false); nav(`/prepared-cart/${settings.selectedCartId}`); }}>
                                {L('localization_common_go_to_cart')}
                            </Button>
                            {canStartNewCart &&
                            <Button appearance="secondary" icon={<NewFilled/>} onClick={async () => { setOpen(false); await startNewCart(); nav('/cart'); }}>
                                {L('localization_cart_new_cart_button')}
                            </Button>}
                            <Button appearance="transparent" onClick={() => setOpen(false)}>{L('localization_common_cancel')}</Button>
                        </DialogActions>
                    </DialogBody>
                </DialogSurface>
            </Dialog>
        </>
    );
};

export default BlockedCartNotice;

